import tw from "twin.macro";

export const ButtonContainer = tw.div`tw-flex tw-mb-16 tw-justify-end`;

export const ActionButtonsWrapper = tw.div`tw-flex tw-flex-row tw-gap-8`;
